module.exports = __webpack_public_path__ + "img/fig08.e5dc30d1.jpg";